import script from "./desk-top.vue?vue&type=script&lang=ts&setup=true"
export * from "./desk-top.vue?vue&type=script&lang=ts&setup=true"

import "./desk-top.vue?vue&type=style&index=0&id=333a4775&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-333a4775"]])

export default __exports__